import { useEffect, useState } from 'react'

import { API_URL } from '@f-fertighaus/applications/Next/api/url'
import { HouseDetail } from '@f-fertighaus/applications/Next/types/houseDetailsResponse'
import { client } from '@f-fertighaus/applications/Next/utils/client'
import { useUserPostcode } from '@f-fertighaus/applications/Next/views/houseDetailPage/HouseSections/sections/VendorDetailsSection/hooks/useUserPostcode'

import { APIResponse } from '../../types/APIResponse'

interface Props {
  houseNid: string
  vendorHasRegionalPrices: boolean
}

interface RegionalPrices {
  price_keyready_display?: number
  price_fitting_display?: number
  price_lego_display?: number
  price_display?: number
}

export const useHouseRegionalPrices = ({
  houseNid,
  vendorHasRegionalPrices
}: Props) => {
  const [regionalPrices, setRegionalPrices] = useState<RegionalPrices>()
  const postcode = useUserPostcode()

  useEffect(() => {
    if (postcode && vendorHasRegionalPrices) {
      const searchParams = new URLSearchParams()

      searchParams.append('nid__in', houseNid)
      searchParams.append('delivery_regions__in', postcode)

      client<APIResponse<HouseDetail>>(
        `${API_URL.houses}?${searchParams.toLocaleString()}`
      ).then(({ results: [houseDataWithRegionalPrices] }) => {
        if (houseDataWithRegionalPrices) {
          const {
            price_keyready_display,
            price_fitting_display,
            price_lego_display
          } = houseDataWithRegionalPrices

          setRegionalPrices({
            price_keyready_display: price_keyready_display,
            price_fitting_display: price_fitting_display,
            price_lego_display: price_lego_display,
            price_display:
              price_keyready_display ||
              price_fitting_display ||
              price_lego_display
          })
        }
      })
    }
  }, [houseNid, postcode, vendorHasRegionalPrices])

  return regionalPrices
}
